/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Businessname1Inputs */

const en_businessname1 = /** @type {(inputs: Businessname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business Name`)
};

const de_businessname1 = /** @type {(inputs: Businessname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firmenname`)
};

/**
* | output |
* | --- |
* | "Business Name" |
*
* @param {Businessname1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const businessname1 = /** @type {((inputs?: Businessname1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Businessname1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_businessname1(inputs)
	return de_businessname1(inputs)
});
export { businessname1 as "businessName" }